import { api } from '../service/api';
import { encodePathSegment } from '../utils/text';



export const belemApi = {
  // Escola
  pesquisaEscola: (escola) => api.post(`/api/mosqueiro/pesquisaescola/${encodePathSegment(escola)}`),
  verifyEscola: (prvId) => api.post(`/api/mosqueiro/verifyEscola/${encodePathSegment(prvId)}`),

  // Aluno
  pesquisaAluno: (aluno, prvId) =>
    api.post(`/api/mosqueiro/pesquisaAluno/${encodePathSegment(aluno)}/${encodePathSegment(prvId)}`),

  // Form / Agendamento
  verifyForm: (escola, aluno, mae, cpf, datanascIso) =>
    api.post(
      `/api/mosqueiro/verifyForm/${encodePathSegment(escola)}/${encodePathSegment(aluno)}/${encodePathSegment(mae)}/${encodePathSegment(cpf)}/${encodePathSegment(datanascIso)}`
    ),
  criarAgendamento: (attId, aluno, mae, nascIso, cpf) =>
    api.post(
      `/api/mosqueiro/criarAgendamento/${encodePathSegment(attId)}/${encodePathSegment(aluno)}/${encodePathSegment(mae)}/${encodePathSegment(nascIso)}/${encodePathSegment(cpf)}`
    ),
  confirmaPdf: (cpf, attId) =>
    api.post(`/api/mosqueiro/confirmaPdf/${encodePathSegment(cpf)}/${encodePathSegment(attId)}`),

  // Datas/Horas
  datasDisponiveis: () => api.post(`/api/mosqueiro/data`),
  horasDisponiveis: (dataBr) => api.post(`/api/mosqueiro/hora/${encodePathSegment(dataBr)}`),

  // Excluir/Recuperar
  excluirAgendamento: (cpf) => api.post(`/api/mosqueiro/excluirAgendamento/${encodePathSegment(cpf)}`),
  recuperarAgendamento: (cpf) => api.post(`/api/mosqueiro/recuperaAgendamento/${encodePathSegment(cpf)}`),
};
